import { Request } from '@/classes/Request.ts'

export const skywardLunchBalance = async (
  studentAccountId: TStudentAccountId,
  options?: { signal?: AbortSignal }
) => {
  const response = await new Request().get(
    '/ajax/student/' + studentAccountId + '/skyward_lunch_balance',
    options
  )
  return response.data.balance
}
